import * as z from "zod";
//#region src/__generated__/internal/payment/zod/paymentViewSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const paymentViewSchema = z.object({
	canApprove: z.boolean().nullish().describe("Доступно ли согласование (кнопка «Согласовать»)"),
	canEditFlag: z.boolean().nullish().describe("Можно ли менять признак оплаты"),
	canIssueInvoice: z.boolean().nullish().describe("Можно ли выставить/изменить счёт"),
	canSendInvoice: z.boolean().nullish().describe("Можно ли отправить счёт заявителю"),
	invoiceAmount: z.number().nullish().describe("Стоимость по счёту, ₽"),
	invoiceNumber: z.string().nullish().describe("Номер счёта"),
	invoiceSentAt: z.iso.datetime().nullish().describe("Дата отправки счёта заявителю"),
	invoiceStatus: z.enum([
		"NOT_ISSUED",
		"ISSUED",
		"SENT"
	]).optional().describe("Статус счёта"),
	paymentFlag: z.enum([
		"UNDER_REVIEW",
		"NO_PAYMENT",
		"PAID"
	]).optional().describe("Признак оплаты"),
	proofFileId: z.uuid().nullish().describe("Идентификатор файла подтверждения оплаты"),
	proofFileName: z.string().nullish().describe("Имя файла подтверждения оплаты")
}).describe("Данные оплаты по заявке (внутренний контур)");
//#endregion
//#region src/__generated__/internal/payment/zod/get4Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const get4PathIdSchema = z.uuid();
const get4Status200Schema = paymentViewSchema.describe("Данные оплаты по заявке (внутренний контур)");
const get4ResponseSchema = get4Status200Schema;
//#endregion
//#region src/__generated__/internal/payment/zod/sendInvoiceSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const sendInvoicePathIdSchema = z.uuid();
const sendInvoiceStatus200Schema = paymentViewSchema.describe("Данные оплаты по заявке (внутренний контур)");
const sendInvoiceResponseSchema = sendInvoiceStatus200Schema;
//#endregion
//#region src/__generated__/internal/payment/zod/setPaymentFlagBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setPaymentFlagBodySchema = z.object({ flag: z.enum([
	"UNDER_REVIEW",
	"NO_PAYMENT",
	"PAID"
]).optional().describe("Новое значение признака") }).describe("Тело запроса установки признака оплаты");
//#endregion
//#region src/__generated__/internal/payment/zod/setFlagSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setFlagPathIdSchema = z.uuid();
const setFlagStatus200Schema = paymentViewSchema.describe("Данные оплаты по заявке (внутренний контур)");
const setFlagResponseSchema = setFlagStatus200Schema;
const setFlagDataSchema = setPaymentFlagBodySchema.describe("Тело запроса установки признака оплаты");
//#endregion
//#region src/__generated__/internal/payment/zod/setInvoiceBodySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setInvoiceBodySchema = z.object({
	amount: z.number().optional().describe("Стоимость по счёту, ₽").meta({ examples: [1500] }),
	invoiceNumber: z.string().optional().describe("Номер счёта").meta({ examples: ["INV-2026-001"] })
}).describe("Тело запроса выставления счёта");
//#endregion
//#region src/__generated__/internal/payment/zod/setInvoiceSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const setInvoicePathIdSchema = z.uuid();
const setInvoiceStatus200Schema = paymentViewSchema.describe("Данные оплаты по заявке (внутренний контур)");
const setInvoiceResponseSchema = setInvoiceStatus200Schema;
const setInvoiceDataSchema = setInvoiceBodySchema.describe("Тело запроса выставления счёта");
//#endregion
export { paymentViewSchema as _, setInvoiceBodySchema as a, setFlagResponseSchema as c, sendInvoicePathIdSchema as d, sendInvoiceResponseSchema as f, get4Status200Schema as g, get4ResponseSchema as h, setInvoiceStatus200Schema as i, setFlagStatus200Schema as l, get4PathIdSchema as m, setInvoicePathIdSchema as n, setFlagDataSchema as o, sendInvoiceStatus200Schema as p, setInvoiceResponseSchema as r, setFlagPathIdSchema as s, setInvoiceDataSchema as t, setPaymentFlagBodySchema as u };

//# sourceMappingURL=setInvoiceSchema.js.map